export const implementation = {
  implementationHero: {
    subtitle: 'IMPLEMENTATION',
    title: '关于导入',
    description: '精致的系统导入路线图',
  },
  flow: {
    subtitle: 'IMPLEMENTATION FLOW',
    title: '导入流程',
    description: '从初次咨询到项目启动，提供系统化的方法。',
    individual: {
      title: '个人',
      steps: [
        {
          number: '01',
          title: '初次咨询',
          description: '了解您的现状和目标',
        },
        {
          number: '02',
          title: '项目选择',
          description: '选择最优课程',
        },
        {
          number: '03',
          title: '开始学习',
          description: '开始结构化学习',
        },
      ],
    },
    corporate: {
      title: '企业',
      steps: [
        {
          number: '01',
          title: '组织听证',
          description: '了解组织课题和目标',
        },
        {
          number: '02',
          title: '定制化',
          description: '设计最优项目',
        },
        {
          number: '03',
          title: '实施与跟进',
          description: '项目执行和持续支持',
        },
        {
          number: '04',
          title: '签约・导入',
          description: '正式签约并开始导入',
        },
      ],
    },
    educational: {
      title: '教育机构',
      steps: [
        {
          number: '01',
          title: '教育理念对齐',
          description: '确认与机构理念的一致性',
        },
        {
          number: '02',
          title: '课程整合',
          description: '与现有课程整合',
        },
        {
          number: '03',
          title: '教育者培训与启动',
          description: '教育者培训和项目启动',
        },
      ],
    },
  },
  faq: {
    subtitle: 'Frequently Asked Questions',
    title: '常见问题',
    items: [
      {
        question: '受讲对象是什么样的人？',
        answer: '以追求组织生产力提升的经营者、培养下一代的教育相关人士为首，面向希望从"结构"重新设计自身成长的志向高远的个人。',
      },
      {
        question: '需要科学或心理学的专业知识吗？',
        answer: '不需要。DREAM CODE将复杂的学术知识体系化为"任何人都可以复现的步骤"。我们重视的不是专业术语的记忆，而是落实到您自身的思考和行动的实践。',
      },
      {
        question: '受讲形式是怎样的？',
        answer: '我们提供收录了讲义和实践性工作坊的视频项目。您可以根据自己的生活方式和日程安排，不受时间和地点限制，反复学习和实践。',
      },
      {
        question: '全48讲座的学习期间（节奏）的参考标准是什么？',
        answer: '课程设计可根据个人的理解程度和实践节奏灵活推进。详细的学习时间表将在导入前的预备面谈中提供最优方案。',
      },
      {
        question: '可以为企业提供培训，或为教育机构提供定制化导入吗？',
        answer: '可以。我们会充分了解组织的理念和当前课题（领导力开发、自主型人才培养等），从48条法则中提取最优模块，重新构建专属课程。',
      },
      {
        question: '请告知课程费用和报名流程。',
        answer: 'DREAM CODE（全48讲座・基础课程）的学费为440,000日元（含税）。\n本学院非常重视学习者当前课题与课程的适配性。请先通过"INQUIRY（咨询事务局）"与我们联系。预备听证（或面谈）后，我们将另行发送个别报名手续及付款说明。\n※针对法人・教育机构的定制化导入，将根据规模和内容单独报价。',
      },
    ],
    button: '联系事务局',
  },
};